import {Component, Inject, ViewEncapsulation, OnInit, OnDestroy} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";
import {AccountService, UserService} from "../../services";
import {User} from "../../models";
import {ServiceService} from "../../services/service.service";
import {Service} from "../../models/service";
import {Observable, of, Subject} from 'rxjs';
import {catchError, debounceTime, map, startWith, switchMap, takeUntil} from 'rxjs/operators';

export const MY_FORMATS = {
    parse: {
        dateInput: ['YYYY-MM-DD']
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {DateAdapter} from "angular-calendar";
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {first} from "rxjs/operators";
import {CustomerDialogComponent} from "../../customer/dialog/customerDialog.component";
import {ServiceResourceGroup} from "../../models/serviceResourceGroup";
import {Items} from "../../models/items";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {GroupActivity} from "../../models/groupActivity";

@Component({
    selector: 'event-form-dialog',
    templateUrl: './eventDialog.component.html',
    styleUrls: ['./eventDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ]
})

export class EventDialogComponent implements OnInit, OnDestroy {
    action: string;
    categories: any[];
    groups: any[];
    reservation: ReservationData;
    eventForm: FormGroup;
    dialogTitle: string;
    customers: User[];
    workers: User[];
    trainers: User[];
    showSeconds = false;
    stepHour = 1;
    stepMinute = 1;
    stepSecond = 0;
    touchUi = true;
    hideTime = false;
    color = "primary";
    services: Service[];
    event: any;
    dialogRef: any;
    worker: User;
    locale: string;
    filteredOptions: Observable<User[]>;
    form: FormGroup;
    public customer = new FormControl();
    isGroupActivity = false;

    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param _formBuilder
     * @param translationLoader
     * @param translate
     */
    constructor(
        public matDialogRef: MatDialogRef<EventDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        private userService: UserService,
        private serviceService: ServiceService,
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private accountService: AccountService,
    ) {
        this._unsubscribeAll = new Subject();
        this.translationLoader.loadTranslations(polish);
        // Set the defaults

        this.action = _data.action;
        this.event = _data.event;
        this.worker = _data.worker;
        this.locale = _data.locale;

        this.userService.getAllCustomers().subscribe((res: Items)=>{
            this.customers = res.items;
            this.filteredOptions = this.eventForm.get('customer').valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(300),
                    switchMap(value => {
                        // Check if value is a string (user is typing) or an object (user selected)
                        if (typeof value === 'string' && value !== '') {
                            return this.lookup(value);
                        } else {
                            return of(null);
                        }
                    })
                );
        }, error => {

        });

        this.userService.getAllTrainers().subscribe((res: Items)=> {
            this.trainers = res.items;
        });

        // this.serviceService.getAll().subscribe((res: Service[])=>{
        //     this.services = res;
        // }, error => {
        //
        // });

        if (this.worker.services) {
            this.services = this.worker.services;
        }

        if (this.action === 'edit') {
            translate.get('Edit reservation').subscribe((text: string) => {
                this.dialogTitle = text
            });

            this.reservation = _data.reservation;
        } else {
            translate.get('New reservation').subscribe((text: string) => {
                this.dialogTitle = text
            });
            this.reservation = new ReservationData();
        }

        this.eventForm = this.createEventForm();
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    public unsubscribe(): void {
        this._unsubscribeAll.next();
    }

    lookup(value: string): Observable<Items> {
        this.unsubscribe();
        return this.userService.getAllCustomersBy(value).pipe(
            takeUntil(this._unsubscribeAll),
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }

    displayFn(userId: User): string {
        return (userId)? userId.firstName + ' ' + userId.lastName + '; ' + userId.phone: '';
    }

    getResourceGroups(serviceId: string): ServiceResourceGroup[] {
        if (serviceId !== null) {
            for (let i = 0; i < this.services.length; i++) {
                if (this.services[i].id !== serviceId) {
                    continue;
                }

                for (let j = 0; j < this.services[i].resourceGroups.length; j++) {
                    this.addReservedResources();
                }

                this.groups = this.services[i].resourceGroups;
                return this.services[i].resourceGroups;
            }
        }

        return [];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create contact form
     *
     * @returns {FormGroup}
     */
    createEventForm(): FormGroup {
        this.isGroupActivity = false;

        if (this.reservation.groupActivity || this.accountService.hasOnlyRole('ROLE_TRAINER')) {
            this.isGroupActivity = true;
        }

        let trainer = null;

        if (this.reservation.groupActivity) {
            trainer = this.reservation.groupActivity.trainer
        }

        if (!trainer && this.accountService.hasOnlyRole('ROLE_TRAINER') && !this.reservation.id) {
            this.reservation.groupActivity = new GroupActivity();
            trainer = this.worker.id;
        }

        let form = this._formBuilder.group({
            id: [this.reservation.id],
            isGroupActivity: [this.isGroupActivity],
            customer: [this.reservation.customer],
            service: [this.reservation.service],
            description: [this.reservation.service],
            reservedResources: this.formBuilder.array([]),
            trainer: [trainer],
        });

        return form;
    }

    get f() { return this.form.controls; }

    reservedResources(): FormArray {
        return this.eventForm.get('reservedResources') as FormArray;
    }

    newReservedResource(): FormGroup {
        return this.formBuilder.group({
            id: ['']
        });
    }

    addReservedResources() {
        this.reservedResources().push(this.newReservedResource());
    }

    removeHour(hourIdx: number) {
        this.reservedResources().removeAt(hourIdx);
    }

    checkGroupActivity(event: MatCheckboxChange) {
        this.isGroupActivity = event.checked;
    }

    openNewCustomerDialog() {
        this.dialogRef = this._matDialog.open(CustomerDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'new',
            },
            width: '700px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if ( !response )
                {
                    return;
                }

                let customerData = response.getRawValue();
                customerData.canAddFirstTimeVoucher = true;

                this.userService.createCustomer(customerData)
                    .pipe(first())
                    .subscribe(
                        (customer: User) => {
                            this.customers.push(customer);
                        },
                        error => {
                            console.log(error);
                        });

            }, (err) => {
                console.log(err);
            });
    }
}
